var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArchived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.5C0.5 1.23478 0.605357 0.98043 0.792893 0.792893C0.98043 0.605357 1.23478 0.5 1.5 0.5H15.5C15.7652 0.5 16.0196 0.605357 16.2071 0.792893C16.3946 0.98043 16.5 1.23478 16.5 1.5V3.5C16.5 3.76522 16.3946 4.01957 16.2071 4.20711C16.0196 4.39464 15.7652 4.5 15.5 4.5V12C15.5 12.663 15.2366 13.2989 14.7678 13.7678C14.2989 14.2366 13.663 14.5 13 14.5H4C3.33696 14.5 2.70107 14.2366 2.23223 13.7678C1.76339 13.2989 1.5 12.663 1.5 12V4.5C1.23478 4.5 0.98043 4.39464 0.792893 4.20711C0.605357 4.01957 0.5 3.76522 0.5 3.5V1.5ZM2.5 4.5V12C2.5 12.3978 2.65804 12.7794 2.93934 13.0607C3.22064 13.342 3.60218 13.5 4 13.5H13C13.3978 13.5 13.7794 13.342 14.0607 13.0607C14.342 12.7794 14.5 12.3978 14.5 12V4.5H2.5ZM15.5 1.5H1.5V3.5H15.5V1.5ZM5.5 7C5.5 6.86739 5.55268 6.74021 5.64645 6.64645C5.74021 6.55268 5.86739 6.5 6 6.5H11C11.1326 6.5 11.2598 6.55268 11.3536 6.64645C11.4473 6.74021 11.5 6.86739 11.5 7C11.5 7.13261 11.4473 7.25979 11.3536 7.35355C11.2598 7.44732 11.1326 7.5 11 7.5H6C5.86739 7.5 5.74021 7.44732 5.64645 7.35355C5.55268 7.25979 5.5 7.13261 5.5 7Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchived);
export default __webpack_public_path__ + "static/media/icon-archived.7410dbe0781de3bd39970d1d3db1162c.svg";
export { ForwardRef as ReactComponent };